export default __webpack_public_path__ + "static/media/Mark-2-HUD-03.6f7b058f.jpg";